import { useSelector } from "react-redux";
import { Outlet } from "react-router-dom";

import { Box, Typography } from "@mui/material";

import { SupportAccess } from "views/SupportConsole/SupportAccess/SupportAccess";
import { SysAdminConsole } from "views/SupportConsole/SysAdminConsole/SysAdminConsole";

export function SupportConsole() {
  const sosImpersonate = useSelector(
    (state) => state.userCompanySettings.supportPrivileges?.sosImpersonate
  );
  const sysAdmin = useSelector(
    (state) => state.userCompanySettings.supportPrivileges?.sysAdmin
  );

  return (
    <Box sx={{ display: "grid", minWidth: "1070px" }} m={2} mb={0}>
      <Box mb={1}>
        <Typography variant="h2">Support console</Typography>
      </Box>
{sosImpersonate && <SupportAccess />}
      {sysAdmin && <SysAdminConsole />}
      <Outlet />
    </Box>
  );
}
